const INDUSTRIES = [
  {
    key: "food_manufacturing",
    title: "Food Manufacturing",
    image:
      "https://images.unsplash.com/photo-1779517226314-ca31137f993d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxmb29kJTIwbWFudWZhY3R1cmluZyUyMGZhY2lsaXR5JTIwY2xlYW58ZW58MHx8fHwxNzgwMDIxNzk0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "hospitality",
    title: "Hospitality",
    image:
      "https://images.pexels.com/photos/12193824/pexels-photo-12193824.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    key: "distribution",
    title: "Distribution",
    image:
      "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxvcmdhbml6ZWQlMjB3YXJlaG91c2UlMjBkaXN0cmlidXRpb258ZW58MHx8fHwxNzgwMDIxNzk0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "import_export",
    title: "Import / Export",
    image:
      "https://images.pexels.com/photos/13025947/pexels-photo-13025947.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export function Industries() {
  return (
    <section id="industries" className="bg-white pb-20 md:pb-28" data-testid="industries-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-4 gap-4 md:gap-5">
          {INDUSTRIES.map((i) => (
            <figure
              key={i.key}
              className="relative overflow-hidden group"
              data-testid={`industry-card-${i.key}`}
            >
              <div className="aspect-[4/5] bg-brand-cream">
                <img
                  src={i.image}
                  alt={i.title}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-[filter] duration-500"
                  loading="lazy"
                />
              </div>
              <figcaption className="mt-3 flex items-baseline justify-between">
                <span
                  className="text-[11px] uppercase tracking-[0.3em] text-brand-navy font-medium"
                  data-testid={`industry-title-${i.key}`}
                >
                  {i.title}
                </span>
                <span className="text-[10px] text-brand-navy/40 tabular-nums">
                  0{INDUSTRIES.findIndex((x) => x.key === i.key) + 1}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
